
import ReactECharts from 'echarts-for-react';

// African country name → ISO alpha-2 (lowercase) for flagcdn.com
const COUNTRY_CODES = {
  'Algeria': 'dz', 'Angola': 'ao', 'Benin': 'bj', 'Botswana': 'bw',
  'Burkina Faso': 'bf', 'Burundi': 'bi', 'Cabo Verde': 'cv', 'Cameroon': 'cm',
  'Central African Republic': 'cf', 'Chad': 'td', 'Comoros': 'km',
  'Congo': 'cg', 'Republic of the Congo': 'cg',
  "Côte d'Ivoire": 'ci', 'Ivory Coast': 'ci', "Cote d'Ivoire": 'ci',
  'Democratic Republic of the Congo': 'cd', 'Dem. Rep. Congo': 'cd', 'DR Congo': 'cd',
  'Djibouti': 'dj', 'Egypt': 'eg', 'Equatorial Guinea': 'gq',
  'Eritrea': 'er', 'Eswatini': 'sz', 'Swaziland': 'sz',
  'Ethiopia': 'et', 'Gabon': 'ga', 'Gambia': 'gm', 'Ghana': 'gh',
  'Guinea': 'gn', 'Guinea-Bissau': 'gw', 'Kenya': 'ke',
  'Lesotho': 'ls', 'Liberia': 'lr', 'Libya': 'ly',
  'Madagascar': 'mg', 'Malawi': 'mw', 'Mali': 'ml',
  'Mauritania': 'mr', 'Mauritius': 'mu', 'Morocco': 'ma',
  'Mozambique': 'mz', 'Namibia': 'na', 'Niger': 'ne', 'Nigeria': 'ng',
  'Rwanda': 'rw', 'São Tomé and Príncipe': 'st', 'Sao Tome and Principe': 'st',
  'Senegal': 'sn', 'Seychelles': 'sc', 'Sierra Leone': 'sl',
  'Somalia': 'so', 'South Africa': 'za', 'South Sudan': 'ss',
  'Sudan': 'sd', 'Tanzania': 'tz', 'United Republic of Tanzania': 'tz',
  'Togo': 'tg', 'Tunisia': 'tn', 'Uganda': 'ug',
  'Zambia': 'zm', 'Zimbabwe': 'zw', 'Western Sahara': 'eh',
};

const CountiesChart = ({data}) => {
  const mobile = typeof window !== 'undefined' && window.innerWidth < 768;

    // Normalize input: accept {cdi:{overview}}, {overview}, or a plain array
    const overview = Array.isArray(data)
        ? data
        : (data?.cdi?.overview ?? data?.overview ?? []);

    if (overview.length === 0) {
        return null;
    }

    const getOption = () => {
        // Detect if this is continental (country_name) vs regional (admin_one_name) data
        const isContinental = overview.length > 0 && !!overview[0].country_name;
        const countries = overview.map(item => item.country_name || item.admin_one_name || 'Unknown');
        const watchData = overview.map(item => item.Watch);
        const warningData = overview.map(item => item.Warning);
        const alertData = overview.map(item => item.Alert);

        const isDataZoomNeeded = countries.length > 100;
        const dataZoomEnd = isDataZoomNeeded ? (22 / countries.length) * 100 : 100;
        const dataZoomOption = isDataZoomNeeded ? [{
          type: 'slider', yAxisIndex: 0, start: 0, end: dataZoomEnd,
          handleSize: '10%', handlePosition: 'top', height: '100%', top: 0
        }] : [];

        // Build rich styles — flags only for continental overview
        const rich = {
          name: {
            fontSize: mobile ? 9 : 11,
            lineHeight: mobile ? 16 : 18,
            verticalAlign: 'middle',
            width: mobile ? 44 : 55,
            overflow: 'truncate',
            padding: [0, 0, 0, 2]
          }
        };
        if (isContinental) {
          countries.forEach(name => {
            const code = COUNTRY_CODES[name];
            if (code) {
              rich[`f_${code}`] = {
                height: mobile ? 10 : 14,
                width: mobile ? 14 : 20,
                lineHeight: mobile ? 14 : 18,
                verticalAlign: 'middle',
                backgroundColor: { image: `https://flagcdn.com/w20/${code}.png` }
              };
            }
          });
        }

        return {
          grid: { left: 0, right: mobile ? '2%' : '4%', bottom: '3%',
                  top: isDataZoomNeeded ? '70px' : '15%', containLabel: true },
          xAxis: { type: 'value', splitLine: { show: false },
                   axisLabel: { show: false }, axisTick: { show: false }, axisLine: { show: false } },
          yAxis: {
            type: 'category', data: countries, inverse: true,
            axisTick: { show: false }, axisLine: { show: false },
            axisLabel: {
              show: true,
              formatter: function(value) {
                if (isContinental) {
                  const code = COUNTRY_CODES[value];
                  if (code) return `{f_${code}|} {name|${value}}`;
                }
                return value;
              },
              rich: rich
            }
          },
          series: [
            { name: 'Watch', type: 'bar', stack: 'total', data: watchData,
              itemStyle: { color: '#fff645' } },
            { name: 'Warning', type: 'bar', stack: 'total', data: warningData,
              itemStyle: { color: '#FFA600' } },
            { name: 'Alert', type: 'bar', stack: 'total', data: alertData,
              itemStyle: { color: 'red' } }
          ],
          dataZoom: dataZoomOption,
          animationEasing: 'elasticOut',
          animationDelayUpdate: (idx) => idx * 8
        };
    };

    return <ReactECharts option={getOption()} style={{ width: '100%', height: mobile ? 260 : 320 }} />;
};

export default CountiesChart;